import lottie from 'lottie-web'
import loadingFile from '@/assets/lottie/data.json'
import { useEffect } from 'react'

interface Props {
  loading: boolean
}

function LoadingFingertip({ loading }: Props) {
  useEffect(() => {
    lottie.loadAnimation({
      container: document.querySelector('#react-logo') as any,
      animationData: loadingFile,
      renderer: 'svg', // "canvas", "html"
      loop: true, // boolean
      autoplay: true, // boolean
    })
  }, [])

  if (loading) return <div id="react-logo" style={{ width: 400 }} />
  return <div />
}

export default LoadingFingertip
